module.exports = __webpack_public_path__ + "img/H2.de45b707.png";